export default {
    data() {
        return {
            img: '',
            rtable: '',
        }
    },
    methods: {
        handlerDownPdf() {
            this.$refs.Charts.chart.resize()
            const chart = this.$refs.Charts.chart
            const img = chart.getDataURL()
            this.img = img
            this.rtable = this.$refs.rightTable.innerHTML
            this.$nextTick(() => {
                const ph = this.$refs.tabBar.$children[4].$el
                const div = document.createElement('div')
                div.setAttribute('id', 'printId')
                div.innerHTML = ph.innerHTML
                document.body.appendChild(div)
                document.getElementById('app').style.display = 'none'
                return
                setTimeout(() => {
                    window.print()
                    document.body.removeChild(div)
                    document.getElementById('app').style.display = 'block'
                }, 300)
            })
        }
    }
}
